var map = {
	"./insaweb.default.DEVELOPMENT.config": 596,
	"./insaweb.default.PRODUCTION.config": 597
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 962;


//////////////////
// WEBPACK FOOTER
// . ^\.\/insaweb\.default\..*\.config$
// module id = 962
// module chunks = 3